import ReportsCompany from "./Company";

export default ReportsCompany;
